import { registerPlugin } from '@capacitor/core';

export interface IPlatformPropertiesPlugin {
  getGoogleMapsApiKey(): Promise<{ apiKey: string }>;
}

const PlatformProperties = registerPlugin<IPlatformPropertiesPlugin>('PlatformPropertiesPlugin');
export default PlatformProperties;
